import { ResponsePageType } from '../utils/ResponsePageModel';
import { Gender } from './constants';

export interface CountryItem {
  countryCode: string;
  nationalityCode: string;
  label: string;
}

export interface DepartmentItem {
  code: string;
  label: string;
  displayedLabel: string;
}

export interface CityItem {
  department: string;
  inseeNumber: string;
  name: string;
  zipCode: string;
}

export interface IdentityInfoModel {
  civility: Gender;
  firstname: string;
  lastname: string;
  nationality: CountryItem;
  birthCountry: CountryItem;
  birthName: string;
  birthDate: string;
  birthDepartment: DepartmentItem;
  // birthCity: CityItem;
}

export interface ContactInfoModel {
  addressMail: string;
  mobilePhone: string;
  homePhone: string;
  employmentPhone: string;
  optinOffer: boolean;
  streetAddress: string;
  additionalAddress?: string;
  zipCode: number;
  cityAddress: CityItem;
}

export interface AddressInfoModel {
  address: string;
  addressBis?: string;
  zipCode: string;
  addressCity: CityItem;
}
export interface NationalityInfoModel {
  nationality: CountryItem;
  birthCountry: CountryItem;
}

export interface BirthInfoModel {
  birthDate: string;
  birthDepartment: DepartmentItem;
  // birthCity: CityItem;
}

export interface HousingInfoModel {
  housingCode: string;
  housingData: string;
}

export interface FamilySituationInfoModel {
  childrenCount: number;
  maritalStatusCode: string;
}
export interface LoansModel {
  realEstateLoans: ImobilierCreditItem[];
  consumerLoans: PersonalCreditItem[];
  creditsProject: string;
  newProjectAmount: number;
}
export interface ImobilierCreditItem {
  id: string;
  amount: number;
  emi: number;
}
export interface PersonalCreditItem {
  id: string;
  amount: number;
  emi: number;
}
export interface ConsentsInfoModel {
  cetelemProject: boolean;
  dossierBoolean: boolean;
}
export interface ProfessionItem {
  id?: string;
  code?: string;
  label?: string;
}

export interface BankItem {
  id?: string;
  code?: string;
  label?: string;
}

export interface ContractItem {
  id?: string;
  code?: string;
  label?: string;
}

export interface SectorItem {
  id?: string;
  code?: string;
}

export enum Score {
  RED = 'R',
  ORANGE = 'O',
  GREEN = 'V',
}

export interface JobInfoModel {
  activitySectorCode: string;
  beginningEmploymentDate?: string;
  employmentContractCode: string;
}

export interface IncomeInfoModel {
  holderSalaryAmount: number;
  monthlyPaymentCount: number;
  familyAllowance: string;
  otherIncome: string;
  pensionIncome: string;
  propertyIncome: string;
  otherIncomeChoice: string;
}

export interface ExpensesInfoModel {
  rentAmount: number;
  acceptTermContract: boolean;
}

export interface ResponseInfoModel {
  responsePageType: ResponsePageType;
}

export interface FraudnetIndoModel {
  jsc: string;
  payload: string;
}
export interface TechnicalDataModel {
  geoLoc: string;
}
export interface AppStoreModel {
  holder?: {
    identity?: IdentityInfoModel;
    job?: JobInfoModel;
    contact?: ContactInfoModel;
    // nationalityInfo?: NationalityInfoModel;
    // birthInfo?: BirthInfoModel;
    // addressInfo?: AddressInfoModel;
  };
  familySituation?: FamilySituationInfoModel;
  housing?: HousingInfoModel;
  loans?: LoansModel;
  consents?: ConsentsInfoModel;
  budget?: {
    expenses?: ExpensesInfoModel;
    income?: IncomeInfoModel;
  };
  responseInfo?: ResponseInfoModel;
  fraudnetInfo?: FraudnetIndoModel;
  redirectUrl?: string;
  technicalData?: TechnicalDataModel;
}
